export default {"src":"/_next/static/media/videoclass-default-light.9a9bd1e5.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};